import { Dropdown } from "primereact/dropdown";
import { useState } from "react";
import { MdOutlineClose, MdOutlineDone } from "react-icons/md";
import { CustomEditStyled } from "./styled";
import { InputNumber } from "primereact/inputnumber";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface ICustomEditInput {
	field: string;
	inputType: "price" | "select";
	selectOptions?: any[];
	onCancel: (field: string) => void;
	onSave: (body: any, field: string) => void;
}

export const CustomEditInput: React.FC<ICustomEditInput> = (props) => {
	const { field, inputType, selectOptions, onSave, onCancel } = props;

	const [currentValue, setCurrentValue] = useState<any>(null);

	const handleChange = (event: any) => {
		setCurrentValue(event);
	};

	const handleOnSave = () => {
		onSave({ [field]: currentValue }, field);
	};

	return (
		<CustomEditStyled>
			<div className="input">
				{inputType === "price" && (
					<InputNumber
						value={currentValue}
						onValueChange={(e) => handleChange(e.value)}
						className="input-material-price w-100"
						placeholder="- R$ 0,00"
						mode="currency"
						currency="BRL"
						locale="pt-BR"
						prefix="- "
					/>
				)}
				{inputType === "select" && (
					<Dropdown
						className="w-100 h-100"
						options={selectOptions}
						value={currentValue}
						onChange={(event) => handleChange(event.value)}
					></Dropdown>
				)}
			</div>
			<div className="d-flex align-items-center actions">
				<OverlayTrigger
					placement={"top"}
					overlay={<Tooltip>Salvar</Tooltip>}
				>
					<div>
						<MdOutlineDone
							size={20}
							onClick={() => handleOnSave()}
						/>
					</div>
				</OverlayTrigger>
				<OverlayTrigger
					placement={"top"}
					overlay={<Tooltip>Cancelar</Tooltip>}
				>
					<div>
						<MdOutlineClose
							size={20}
							onClick={() => onCancel(field)}
						/>
					</div>
				</OverlayTrigger>
			</div>
		</CustomEditStyled>
	);
};
